import { Theme } from '@eversports/react-components/design-tokens/theme'
import Collapse from '@eversports/react-components/primitives/Collapse'
import Flex from '@eversports/react-components/primitives/Flex'
import Icon, { Icons } from '@eversports/react-components/primitives/Icon'
import Text from '@eversports/react-components/primitives/Text'
import { makeStyles } from '@mui/styles'
import React, { useState } from 'react'

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    border: `1px solid ${theme.palette.border}`,
    borderRadius: theme.borderRadii.large,
  },
  header: {
    cursor: 'pointer',
    padding: `${theme.layoutSpacing.dense} ${theme.layoutSpacing.default}`,
  },
  chevronContainer: ({ isOpen }: { isOpen: boolean }) => ({
    transform: isOpen ? 'rotate(180deg)' : 'rotate(0)',
    transition: `all ${theme.transitions.duration.short}ms`,
  }),
  content: {
    borderTop: `1px solid ${theme.palette.border}`,
    padding: `${theme.layoutSpacing.dense} ${theme.layoutSpacing.default}`,
  },
}))

interface Props {
  title: React.ReactNode
  subtitle?: React.ReactNode
  isDefaultOpen?: boolean
}

const Accordion = ({ title, subtitle, isDefaultOpen = false, children }: React.PropsWithChildren<Props>) => {
  const [isOpen, setIsOpen] = useState(isDefaultOpen)
  const classes = useStyles({ isOpen })

  return (
    <div className={classes.container}>
      <Flex
        justifyContent="space-between"
        alignItems="center"
        className={classes.header}
        onClick={() => setIsOpen(!isOpen)}
      >
        <Flex flexDirection="column">
          <Text size="small" fontWeight="bold">
            {title}
          </Text>
          {subtitle && (
            <Text size="small" color="darkGray">
              {subtitle}
            </Text>
          )}
        </Flex>
        <span className={classes.chevronContainer}>
          <Icon icon={Icons.EXPAND_MORE} size="large" />
        </span>
      </Flex>
      <Collapse in={isOpen}>
        <div className={classes.content}>{children}</div>
      </Collapse>
    </div>
  )
}

export default Accordion
